import { render, staticRenderFns } from "./p33.vue?vue&type=template&id=8a76da6e&scoped=true&"
import script from "./p33.vue?vue&type=script&lang=js&"
export * from "./p33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a76da6e",
  null
  
)

export default component.exports